import React from "react";
import {
  Datagrid,
  TextField,
  List,
  ReferenceField,
  ShowButton,
} from "react-admin";

const ZoneList = ({ filter }) => {
  return (
    <List title=" " basePath={"/zones"} resource="zones" filter={filter}
    component={"div"}>
      <Datagrid>
        <TextField source="name" />
        <ReferenceField
          label="Organization"
          source="OrganizationId"
          reference="organizations"
          link="show"
        >
          <TextField source="name" />
        </ReferenceField>        
        <TextField source="notes" />
        <ShowButton />
      </Datagrid>
    </List>
  );
};

export default ZoneList;